import { Component, Inject, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FeriadoService } from 'src/app/modules/services/feriado/feriado.service';
import { forkJoin } from 'rxjs'; // Importante para as múltiplas chamadas
import { LoadingService } from 'src/app/modules/components/loading/loading.service';
import { ToastService } from 'src/app/modules/services/toast/toast.service';

@Component({
  selector: 'app-modal-clone-feriado',
  templateUrl: './modal-clone-feriado.component.html',
  styleUrls: ['./modal-clone-feriado.component.scss']
})
export class ModalCloneFeriadoComponent implements OnInit {
  form!: FormGroup;
  anosOrigem: any= [];
  anosDestino: any= [];
  loading: boolean = false;

  constructor(
    private fb: FormBuilder,
    private dialogRef: MatDialogRef<ModalCloneFeriadoComponent>,
    private loadingService: LoadingService,
    private toastService: ToastService,
    private feriadoService: FeriadoService,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    this.createForm();
  }

  ngOnInit(): void {
    this.carregarDadosIniciais();
  }

  createForm() {
    this.form = this.fb.group({
      anoOrigem: [null, [Validators.required]],
      anoDestino: [null, [Validators.required]],
      apenasRecorrentes: [false]
    });
  }

  carregarDadosIniciais() {
    this.loadingService.showLoading();
    forkJoin({
      origem: this.feriadoService.getAnosOrigem(),
      destino: this.feriadoService.getAnosDestino()
    }).subscribe({
      next: (res) => {
        this.anosOrigem = res.origem;
        this.anosDestino = res.destino;
//           this.anosDestino = [
//     2031,
//     2030,
//     2029,
//     2028,
//     2027,
//     2026
// ]
        this.loadingService.hideLoading();
      },
     error: (erro: any) => {
          if (erro.status !== 500 && erro.status) {
            this.toastService.showError(erro.error.message);
             this.loadingService.hideLoading();
          } else {
            this.toastService.showError('Sistema indisponível. Estamos trabalhando para resolver. Por favor, tente novamente mais tarde.');
             this.loadingService.hideLoading();
          }
        }
    });
  }

  handleSubmit() {
    if (this.form.valid && !this.loading) {
      const payload = {
        anoOrigem: Number(this.form.value.anoOrigem),
        anoDestino: Number(this.form.value.anoDestino),
        apenasRecorrentes: !!this.form.value.apenasRecorrentes
      };

      this.loadingService.showLoading();
      this.feriadoService.copiarFeriados(payload).subscribe({
        next: () => {
          this.toastService.showSuccess('Feriados copiados com sucesso.')
          this.dialogRef.close(true)},
         error: (erro: any) => {
          if (erro.status !== 500 && erro.status) {
            this.toastService.showError(erro.error.message);
             this.loadingService.hideLoading();
          } else {
            this.toastService.showError('Sistema indisponível. Estamos trabalhando para resolver. Por favor, tente novamente mais tarde.');
             this.loadingService.hideLoading();
          }
    }});
    }
  }

  back(): void {
    this.dialogRef.close(false);
  }
}